import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BokkzIbDataService, Aangifte} from "@snelstart-ventures/fiscaal/domain-logic";

@Component({
    selector: 'snelstart-venture-fiscaal-feature-tekst-persoonlijk-kinderen',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './tekst-persoonlijk-kinderen.component.html',
    styleUrl: './tekst-persoonlijk-kinderen.component.scss',
})
export class TekstPersoonlijkKinderenComponent implements OnInit {

    @Input() public id!: string;
    public ibAangifte = {} as Aangifte;
    public focusedElementId: string | null = null;
    public year = 2024;
    public actualYear: number = new Date().getFullYear();

    public bedragLevensonderhoud = 0;

    constructor(
        public dataService: BokkzIbDataService) {
    }

    ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((value) => {
            if (value.year !== undefined) {
                this.year = value.year;
            }
            if (this.year === 2023) {
                this.bedragLevensonderhoud = 488;
            }
            if (this.year === 2024) {
                this.bedragLevensonderhoud = 512;
            }
            if (this.year === 2025) {
                this.bedragLevensonderhoud = 529;
            }
        })
    }

}
